import { Button } from "antd";

export default function CustomButton({ children,className,...rest}) {
return <Button className={`${className} shadow-none `} {...rest}>
  {children}
</Button>
}
  